export default "__VITE_ASSET__dEPfjz8N__"